export default function SocialImage({ alt, social, className }) {
    const imageUrl = new URL(`../../resources/images/social/${social.toLowerCase()}.png`, import.meta.url).href;

    return <img src={imageUrl} alt={alt} className={className} />;
}
